import React, { PropTypes } from 'react'
import classnames from 'classnames'
require('../../styles/_cards.styl')

/** Card */
const Card = ({ style, children, className }) => (
  <div className={ classnames('dsg-card', className) }
              style={ style }>
    { children }
  </div>
)


Card.propTypes = {
  /** Add your own styles */
  style: PropTypes.object,
  /** Class of the component */
  className: PropTypes.string
}

export default Card



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Card/index.js